import type { RouteObject } from "react-router-dom";

import { RouteErrorPage } from "./RouteErrorPage";

/**
 * Wrap a set of sibling routes in a pathless route carrying the
 * ``errorElement``.
 *
 * Why pathless rather than putting ``errorElement`` on the parent:
 * React Router renders a route's ``errorElement`` *in place of that
 * route*. Hang it on the layout route and a failing page takes the
 * layout down with it — the customer loses the header and footer, the
 * admin loses the sidebar. A pathless wrapper sits one level below the
 * layout, so the error screen renders into the layout's ``<Outlet />``
 * and the chrome around it survives.
 *
 * That's also why this is applied at each chrome boundary (the shell
 * tree under ``App``, and again under ``AdminLayout``) instead of once
 * at the root: an error bubbles to the *nearest* ``errorElement``, and
 * the nearest one decides which chrome is still standing.
 */
export function withRouteErrorBoundary(children: RouteObject[]): RouteObject[] {
  return [{ errorElement: <RouteErrorPage />, children }];
}
